module.exports = __webpack_public_path__ + "img/product-29.21c284bd.jpg";